<template>
  <div :ref="refname"></div>
</template>

<script>
import _ from 'lodash'
import { createChart } from 'lightweight-charts'
import { mapState } from 'vuex'

const maxHeight = 300

export default {
  data() {
    return {
      chartOptions: {
        colors: ['#08B64D'],
      },
      refname: 'newsChart' + Math.floor(Math.random() * 100000),
    }
  },
  computed: {
    ...mapState('layout', {
      themeBlack: (state) => state.themeBlack,
    }),
  },
  props: {
    chartData: Array,
  },
  methods: {
    createChart() {
      this.chart = createChart(this.$refs[this.refname], {
        width: this.$refs[this.refname].offsetWidth,
        height: maxHeight,
        timeScale: {
          timeVisible: true,
          secondsVisible: false,
          borderVisible: false,
        },
        rightPriceScale: {
          scaleMargins: {
            top: 0.1,
            bottom: 0.2,
          },
        },
        watermark: {
          visible: true,
          fontSize: 12,
          horzAlign: 'right',
          vertAlign: 'bottom',
          color: 'rgba(0,166,203, 0.8)',
          text: 'Putinomics Sentiment',
        },
        layout: {
          backgroundColor: this.themeBlack ? '#000000' : '#ffffff',
          textColor: this.themeBlack ? '#d1d4dc' : '#333',
        },
        grid: {
          vertLines: {
            visible: false,
          },
          horzLines: {
            color: this.themeBlack ? 'rgba(42, 46, 57, 0.5)' : '#eee',
          },
        },
        handleScroll: false,
        handleScale: false,
        localization: {
          locale: 'ru-RU',
        },
      })

      this.areaSeries = this.chart.addAreaSeries({
        topColor: 'rgba(0,166,203, 0.8)',
        bottomColor: 'rgba(0,166,203, 0.04)',
        lineColor: '#00a6cb',
        lineWidth: 2,
        symbol: 'A',
        autoscaleInfoProvider: () => {
          return {
            priceRange: {
              minValue: 0,
              maxValue: 100,
            },
          }
        },
      })
      this.chart.priceScale('right').applyOptions({
        autoscale: true,
      })

      const that = this
      this.throttledResize = _.throttle(() => {
        if (that.chart) {
          that.chart.applyOptions({
            width: that.$refs[that.refname].offsetWidth,
            height: maxHeight,
          })
          that.chart.timeScale().fitContent()
        }
      }, 50)

      window.addEventListener('resize', this.throttledResize)
    },
    setData() {
      this.areaSeries.setData(
        this.chartData
          .map((el) => ({ ...el, value: el.value * 100 }))
          .sort((a, b) => a.time - b.time)
      )
      const sorted = [...this.chartData].sort((a, b) => a.value - b.value)
      this.areaSeries.applyOptions({
        autoscaleInfoProvider: () => ({
          priceRange: {
            minValue: sorted[0].value * 100,
            maxValue: sorted[sorted.length - 1].value * 100,
          },
        }),
      })
      this.chart.timeScale().fitContent()
    },
  },
  beforeDestroy() {
    if (this.chart) delete this.chart
    this.$refs[this.refname].innerHTML = ''
  },
  watch: {
    chartData() {
      this.setData()
    },
    themeBlack(val) {
      this.chart.applyOptions({
        layout: {
          backgroundColor: val ? '#000000' : '#ffffff',
          textColor: val ? '#d1d4dc' : '#333',
        },
        grid: {
          vertLines: {
            visible: false,
          },
          horzLines: {
            color: val ? 'rgba(42, 46, 57, 0.5)' : '#eee',
          },
        },
      })
    },
  },
  mounted() {
    this.createChart()
    this.setData()
  },
}
</script>

<style lang="scss">
.switchs-graph {
  @media (max-width: 575px) {
    height: auto !important;
  }
}
</style>
